import React from 'react';

import { StyleSheet } from '@lyearn/style';
import { Box, Scrollable } from '@lyearn/ui';

import FilterActions from '../FilterActions';
import FilterGroup from '../FilterGroup';
import FilterLabel from '../FilterLabel';
import { StaticFilterProps } from '../types';
import { getMappedGroupToSelectedItems } from '../utils';

const styles = StyleSheet.create({
  scrollView: {
    maxHeight: 400,
  },
});

const StaticFilterMobile = (props: StaticFilterProps) => {
  const {
    groups,
    label,
    isGroupSelectionEnabled,
    actions,
    itemRenderer,
    selectedFilters,
    showActionButtons,
    isSingleSelect,
  } = props;

  const { toggleOption, addMultiple, removeMultiple, onApplyFilters, addSingle, clearSelection } =
    actions;

  const groupAndItemsMap = React.useMemo(
    () => getMappedGroupToSelectedItems(groups, selectedFilters),
    [groups, selectedFilters],
  );

  return (
    <Box className="insert-padding-bottom-screen android:pb-16">
      {!label ? null : <FilterLabel className="native:pt-8 px-24 pt-32" label={label} />}
      <Scrollable
        bounces={false}
        className="overflow-y-auto px-12 pt-10 pb-8"
        style={styles.scrollView}>
        {groups.map((filterGroup, index) => {
          const showDivider = index < groups.length - 1;
          const selectedItemsOfGroup = groupAndItemsMap[filterGroup.id];

          return (
            <FilterGroup
              key={filterGroup.id}
              addMultiple={addMultiple}
              filterGroup={filterGroup}
              isGroupSelectionEnabled={isGroupSelectionEnabled}
              itemRenderer={itemRenderer}
              removeMultiple={removeMultiple}
              selectedItemsOfGroup={selectedItemsOfGroup}
              showDivider={showDivider}
              onOptionClick={isSingleSelect ? addSingle : toggleOption}
            />
          );
        })}
      </Scrollable>
      {showActionButtons ? (
        <FilterActions onClear={clearSelection} onSave={onApplyFilters} />
      ) : null}
    </Box>
  );
};

export default React.memo(StaticFilterMobile);
